var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.21 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.76,12.92c2.45,0,5.53-1.71,7.36-4A13,13,0,0,0,33,1.1,5.32,5.32,0,0,0,32.88,0a12,12,0,0,0-8,4.27,12.33,12.33,0,0,0-3,7.59,4.5,4.5,0,0,0,.11,1A3.5,3.5,0,0,0,22.76,12.92ZM14.13,56c3.35,0,4.83-2.31,9-2.31s5.18,2.24,8.91,2.24,6.12-3.49,8.43-6.91a31.75,31.75,0,0,0,3.73-7.94A12.25,12.25,0,0,1,37,29.76a12.75,12.75,0,0,1,5.83-10.68,12.62,12.62,0,0,0-10.74-5.55c-4.11,0-7.46,2.56-9.56,2.56-2.28,0-5.29-2.42-8.85-2.42C6.87,13.67,0,19.44,0,30.33A35.2,35.2,0,0,0,5.7,48.88C8.39,52.8,10.74,56,14.13,56Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBlack);
export default __webpack_public_path__ + "static/media/apple-black.59f185fc.svg";
export { ForwardRef as ReactComponent };